import axios, { AxiosRequestConfig } from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'

import settings from 'config/settings'

interface Config extends AxiosRequestConfig {
	path?: string
}
export const apiRequest = async (config: Config) => {
	const { method, path, headers, data, ...rest } = config
	const { API_BASE_URL, apiDebugging } = settings
	const url = API_BASE_URL + '/' + path

	try {
		const fbUser = firebase.auth().currentUser
		if (!fbUser) {
			throw Error('No current user')
		}
		const { uid } = fbUser
		const token = await fbUser.getIdToken()

		const firebaseHeaders = { uid, token }

		if (apiDebugging) {
			console.log(`API REQUEST - ${path}:`, { method, url, headers, data })
		}
		const response = await axios({
			method,
			url,
			data,
			headers: { ...firebaseHeaders, ...(headers ? headers : {}) },
			...rest,
		})
		if (apiDebugging) {
			console.log(`API RESPONSE - ${path}:`, response)
		}
		return response
	} catch (e) {
		console.log(e)
		if (apiDebugging) {
			console.log(`API ERROR - ${path}:`, e)
		}
		throw e
	}
}
